import fields from './fields';
import labels from './labels';
import { routes } from './paths';

export const homeBreadcrumbs = Object.freeze([
  {
    id: fields.home,
    name: labels.HOME,
    pathname: routes.home,
  },
]);

export const actionsBreadcrumbs = Object.freeze([
  ...homeBreadcrumbs,
  {
    id: fields.myActions,
    name: labels.MY_ACTIONS,
    pathname: routes.myActions,
  },
]);

export const activateFxAccountBreadcrumb = {
  id: fields.activateFxAccount,
  name: labels.ACTIVATE_FXACCOUNT,
};

export const manageDigitalAssetsBreadcrumbs = Object.freeze([
  ...homeBreadcrumbs,
  {
    id: fields.manageDigitalAssets,
    name: labels.MANAGE_DIGITAL_ASSETS,
    pathname: routes.manageDigitalAssets,
  },
]);

export const fxAccountBreadcrumbs = Object.freeze([
  ...manageDigitalAssetsBreadcrumbs,
  {
    id: fields.fxAccount,
    name: labels.FX_ACCOUNT,
    pathname: routes.manageDigitalAssetsFxAccount,
  },
]);

export const updateFxAccountPasswordBreadcrumb = {
  id: fields.updatePassword,
  name: labels.UPDATE_PASSWORD,
};

export const manageContactsBreadcrumbs = Object.freeze([
  ...homeBreadcrumbs,
  {
    id: fields.manageContacts,
    name: labels.CONTACTS,
    pathname: routes.manageContacts,
  },
]);

export const contactInformationBreadcrumbs = Object.freeze([
  ...manageContactsBreadcrumbs,
  {
    id: fields.contactInfo,
    name: labels.CONTACT_INFO,
    pathname: routes.manageContactsContactInfo,
  },
]);

export const updateContactBreadcrumb = {
  id: fields.updateContactInfo,
  name: labels.UPDATE_CONTACT_INFO,
};

export const userDetailsBreadcrumbs = Object.freeze([
  ...homeBreadcrumbs,
  {
    id: fields.userDetails,
    name: labels.USER_DETAILS,
  },
]);

export const combineBaseBreadcrumbWithFinal = (
  baseBreadcrumb,
  finalBreadcrumb
) => Object.freeze([...baseBreadcrumb, finalBreadcrumb]);
